export const TimelineSpacer = () => {
  return <div className="h-32">&nbsp;</div>;
};
